/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AddressDto } from "./AddressDto";
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
} from "./AddressDto";

/**
 *
 * @export
 * @interface ProvisionDeviceRequest
 */
export interface ProvisionDeviceRequest {
    /**
     * DeviceIdentity and DeviceType are the only mandatory fields
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    deviceIdentity?: string;
    /**
     * DeviceIdentity and DeviceType are the only mandatory fields
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    deviceType?: ProvisionDeviceRequestDeviceTypeEnum;
    /**
     * Deprecated, prefer DeviceCatalogueId. Define a provisional Vendor. This will be overwritten by the device during first BootNotification.
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    vendor?: string;
    /**
     * Deprecated, prefer DeviceCatalogueId. Define a provisional Model. Useful for fetching model specific configuration schema (via GET lookup/device-configuration-schema?model=parameter). This will be overwritten by the device during first BootNotification.
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    model?: string;
    /**
     *
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    friendlyName?: string;
    /**
     * Optional, IANA time zone id
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    timeZone?: string;
    /**
     * Optional, ChargePoint devices only. Temporary parameter only to fix #1661, will eventually be replaced by separate ThirdPartyPassthrough API in #1489
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    managedBy?: ProvisionDeviceRequestManagedByEnum;
    /**
     * Required, unless staff with system_provisioning permission. Users with only device_provisioning permission must specify their own org. Partners with partner_device_provisioning may specify a child org.
     * @type {string}
     * @memberof ProvisionDeviceRequest
     */
    organisationId?: string;
    /**
     * Optional, link device to an existing DeviceCatalogue entry. Replaces providing Vendor/Model fields.
     * @type {number}
     * @memberof ProvisionDeviceRequest
     */
    deviceCatalogueId?: number;
    /**
     *
     * @type {AddressDto}
     * @memberof ProvisionDeviceRequest
     */
    deviceAddress?: AddressDto;
}

/**
 * @export
 */
export const ProvisionDeviceRequestDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type ProvisionDeviceRequestDeviceTypeEnum =
    (typeof ProvisionDeviceRequestDeviceTypeEnum)[keyof typeof ProvisionDeviceRequestDeviceTypeEnum];

/**
 * @export
 */
export const ProvisionDeviceRequestManagedByEnum = {
    ChargefoxDev: "ChargefoxDev",
    ChargefoxStaging: "ChargefoxStaging",
    ChargefoxProd: "ChargefoxProd",
    Illuminate: "Illuminate",
    Exploren: "Exploren",
    Fortum: "Fortum",
    ChargeHq: "ChargeHq",
    DynamicPassthroughParent: "DynamicPassthroughParent",
    DynamicPassthroughChild: "DynamicPassthroughChild",
    GatewayDynamicPassthroughChild: "GatewayDynamicPassthroughChild",
    ServerlessFunctionApp: "ServerlessFunctionApp",
} as const;
export type ProvisionDeviceRequestManagedByEnum =
    (typeof ProvisionDeviceRequestManagedByEnum)[keyof typeof ProvisionDeviceRequestManagedByEnum];

/**
 * Check if a given object implements the ProvisionDeviceRequest interface.
 */
export function instanceOfProvisionDeviceRequest(
    value: object,
): value is ProvisionDeviceRequest {
    return true;
}

export function ProvisionDeviceRequestFromJSON(
    json: any,
): ProvisionDeviceRequest {
    return ProvisionDeviceRequestFromJSONTyped(json, false);
}

export function ProvisionDeviceRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ProvisionDeviceRequest {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        vendor: json["vendor"] == null ? undefined : json["vendor"],
        model: json["model"] == null ? undefined : json["model"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
        timeZone: json["timeZone"] == null ? undefined : json["timeZone"],
        managedBy: json["managedBy"] == null ? undefined : json["managedBy"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        deviceCatalogueId:
            json["deviceCatalogueId"] == null
                ? undefined
                : json["deviceCatalogueId"],
        deviceAddress:
            json["deviceAddress"] == null
                ? undefined
                : AddressDtoFromJSON(json["deviceAddress"]),
    };
}

export function ProvisionDeviceRequestToJSON(
    value?: ProvisionDeviceRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        deviceType: value["deviceType"],
        vendor: value["vendor"],
        model: value["model"],
        friendlyName: value["friendlyName"],
        timeZone: value["timeZone"],
        managedBy: value["managedBy"],
        organisationId: value["organisationId"],
        deviceCatalogueId: value["deviceCatalogueId"],
        deviceAddress: AddressDtoToJSON(value["deviceAddress"]),
    };
}
